import { render, staticRenderFns } from "./pro-link-list.vue?vue&type=template&id=05ee4b94&scoped=true"
import script from "./pro-link-list.vue?vue&type=script&lang=js"
export * from "./pro-link-list.vue?vue&type=script&lang=js"
import style0 from "./pro-link-list.vue?vue&type=style&index=0&id=05ee4b94&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ee4b94",
  null
  
)

export default component.exports